import React from 'react';
import './App.css';
import { FeedView } from './components/FeedView';
import { useTheme } from './hooks/useTheme';

function App() {
  const { theme, toggleTheme } = useTheme();

  return (
    <div className="App">
      <header className="app-header">
        <div className="header-left">
          <h1 className="app-title">socii/FEED</h1>
        </div>
        <div className="header-right">
          <button className="header-icon compose-button" title="Compose">✏️</button>
          <button className="header-icon friends-button" title="Friends">👥</button>
          <span className="friends-count">0</span>
          <button 
            onClick={toggleTheme}
            className="header-icon theme-toggle"
            title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} theme`}
          >
            {theme === 'dark' ? '☀️' : '🌙'}
          </button>
        </div>
      </header>
      <main className="app-main">
        <FeedView />
      </main>
    </div>
  );
}

export default App;
